import { useEffect, useState } from "react";
import Header from "../../Common/Header";
import { OrderHistoryData } from "../../api/get";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../loader";
import { Link,useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";
const OrderHistory = () => {
  const [contentLoder, setContentLoader] = useState(true);
  const [OrderData, setOrderData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    OrderHistoryData()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setOrderData(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  console.log("OrderData =>", OrderData);
  return (
    <>
      {contentLoder ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container mx-auto">
            <div className="grid mt-[15px] grid-cols-1 mx-5">
              <div className="mt-10">
                <h1 className="text-2xl font-bold mb-6">Order History</h1>
                <div className="overflow-x-auto lg:overflow-x-visible">
                  <table className="min-w-full border-collapse border border-gray-200 bg-white">
                    <thead>
                      <tr className="bg-primary text-white ">
                        <th className="border border-gray-200 px-5 py-2 text-left">
                          #
                        </th>
                        <th className="border border-gray-200 px-4 py-2 text-left min-w-[150px]">
                          Package Name
                        </th>
                        <th className="border border-gray-200 px-4 py-2 text-left">
                          Grand Total (A$)
                        </th>
                        <th className="border border-gray-200 px-4 py-2 text-left">
                          Subscription Price (A$)
                        </th>
                        <th className="border border-gray-200 px-4 py-2 text-left">
                          End Date
                        </th>
                        <th className="border border-gray-200 px-4 py-2 text-left">
                          Subscription
                        </th>
                        <th className="border border-gray-200 px-4 py-2 text-left">
                          Order Status
                        </th>
                        <th className="border border-gray-200 px-4 py-2 text-left">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {OrderData.map((order, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="border border-gray-200 px-5 py-2 font-bold opacity-70 ">
                            {index + 1}
                          </td>
                          <td className="border border-gray-200 px-4 py-2 font-bold opacity-70 min-w-[150px]">
                            {order.package_name}
                            {/* Display the "New" label if the order is the latest "success" order */}
                            {order.current && (
                              <span className="rounded-[5px] bg-primary text-white p-1 ml-3 font-bold text-[13px]">
                                Current
                              </span>
                            )}
                          </td>
                          <td className="border border-gray-200 px-4 py-2">
                            {order.amount_grand_total}
                          </td>
                          <td className="border border-gray-200 px-4 py-2">
                            {order.subscription_price || "N/A"}
                          </td>
                          <td className="border border-gray-200 px-4 py-2">
                            {order.subscription_end_date
                              ? new Date(
                                  order.subscription_end_date
                                ).toLocaleString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  hour12: false,
                                })
                              : "N/A"}
                          </td>
                          <td className="border border-gray-200 px-4 py-2">
                            {order.is_subscription === 1 ? "Yes" : "No"}
                          </td>
                          <td className="border border-gray-200 px-4 py-2">
                            {order.order_status
                              ? order.order_status.charAt(0).toUpperCase() +
                                order.order_status.slice(1)
                              : "N/A"}
                          </td>
                          <td className="border border-gray-200 px-4 py-2">
                            <Link to={`/order-details/${order.id}`}>
                              <button
                                type="button"
                                className="bg-primary text-white px-3 py-2 rounded-[5px] font-bold"
                              >
                                View
                              </button>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-[30px]">
                  <Link to={"/dashboard"}>
                    <button className="flex items-center justify-center gap-1 font-bold text-[16px] py-2 rounded-[10px] mt-5 text-slate-500 bg-primary text-white px-3">
                      <FaAngleLeft />
                      Back
                    </button>
                  </Link>
                </div>
              </div>
              {/* <div className="border-b-2 my-5"></div> */}
              {/* <div>
                <div className="max-lg:hidden bg-no-repeat ">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/10.png" alt="mascot" />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OrderHistory;
